import { API } from 'widget/helpers/axios';

const buildUrl = (endPoint, conversationId) => {
  let url = `/api/v1/${endPoint}${window.location.search}`;
  if (conversationId) {
    const separator = window.location.search ? '&' : '?';
    url += `${separator}conversation_id=${conversationId}`;
  }
  return url;
};

export default {
  create(label, conversationId) {
    return API.post(buildUrl('widget/labels', conversationId), { label });
  },
  destroy(label, conversationId) {
    return API.delete(buildUrl(`widget/labels/${label}`, conversationId));
  },
};
